"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        /**
         * Framework class for Toolbar control
         */
        var Toolbar = /** @class */ (function (_super) {
            __extends(Toolbar, _super);
            function Toolbar(data, element, parent, role) {
                var _this = _super.call(this, data, element, parent, role) || this;
                _this._toolBarElementOverFlowMap = {};
                $dyn.setValue(_this, "ArrangeMethod", $dyn.layout.ArrangeMethod.none);
                return _this;
            }
            Object.defineProperty(Toolbar.prototype, "$overflowArea", {
                get: function () {
                    if (!this._overflowArea || !this._overflowArea.length) {
                        this._overflowArea = $(this.element.querySelector(".overflow-menu"));
                    }
                    return this._overflowArea;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(Toolbar.prototype, "$toolbar", {
                get: function () {
                    if (!this._toolbar || !this._toolbar.length) {
                        this._toolbar = $(this.element);
                    }
                    return this._toolbar;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(Toolbar.prototype, "$overflowButton", {
                get: function () {
                    if (!this._overflowButton || !this._overflowButton.length) {
                        this._overflowButton = $(this.element.querySelector(".toolbar-overflow"));
                    }
                    return this._overflowButton;
                },
                enumerable: false,
                configurable: true
            });
            Toolbar.prototype.init = function (data, element) {
                var _this = this;
                _super.prototype.init.call(this, data, element);
                this.OverflowMenuOpen = $dyn.observable(false);
                /**
                 * Calculates width of all Toolbar children and stores them for later use.
                 */
                var calculateChildWidths = function () {
                    // For Toolbar, both tabs and button groups are sent down as ToolbarGroup. Tabs will have other button groups as immediate children.
                    _this.$toolbar.children().each(function (index, toolbarChildElement) {
                        if (toolbarChildElement.getAttribute("data-dyn-role") === "ToolbarGroup") {
                            toolbarChildElement.dynWidth = parseInt(window.getComputedStyle(toolbarChildElement).marginLeft, 10);
                            $(toolbarChildElement).children().each(function (childIndex, childElement) {
                                if (childElement.getAttribute("data-dyn-role") === "ToolbarGroup") {
                                    childElement.dynWidth = parseInt(window.getComputedStyle(childElement).marginLeft, 10);
                                    $(childElement).children().each(function (grandChildindex, grandChild) {
                                        grandChild.dynWidth = grandChild.offsetWidth;
                                    });
                                }
                                else { // these are buttons
                                    childElement.dynWidth = childElement.offsetWidth;
                                }
                            });
                        }
                        else {
                            // These will be the divs for the replace content handler.
                            // dynWidth needs to be set on these elements as it is used in overflow calculations.
                            toolbarChildElement.dynWidth = toolbarChildElement.offsetWidth + parseInt(window.getComputedStyle(toolbarChildElement).marginLeft, 10);
                        }
                    });
                };
                /**
                 * Retrieves width of Toolbar content.
                 * @returns Width of Toolbar content
                 */
                var toolbarContentWidth = function () {
                    var contentWidth = 0;
                    _this.$toolbar.children().each(function (index, toolbarChildElement) {
                        // Reserve width for the overflow button if needed
                        if (_this.$overflowButton && toolbarChildElement === _this.$overflowButton[0] && _this._checkOverflowAreaHasChildren()) {
                            contentWidth += parseInt(window.getComputedStyle(_this.$overflowButton[0]).width, 10);
                            return false;
                        }
                        // Reserve width of elements if they are not marked to always be in overflow
                        if (!toolbarChildElement.classList.contains("toolbarGroup-alwaysInOverflow")) {
                            contentWidth += isNaN(toolbarChildElement.dynWidth) ? 0 : toolbarChildElement.dynWidth;
                            $(toolbarChildElement).children().each(function (childIndex, childElement) {
                                contentWidth += isNaN(childElement.dynWidth) ? 0 : childElement.dynWidth;
                                if (childElement.getAttribute("data-dyn-role") === "ToolbarGroup") {
                                    $(childElement).children().each(function (grandChildindex, grandChild) {
                                        contentWidth += grandChild.dynWidth;
                                    });
                                }
                            });
                        }
                    });
                    return contentWidth;
                };
                /**
                 * Apply classes to items that need to always be in overflow area
                 */
                var markAlwaysInOverflowItems = function () {
                    _this.$toolbar.children('[data-dyn-role="ToolbarGroup"]').each(function (index, groupElement) {
                        if ($dyn.context(groupElement).AlwaysInOverflow) {
                            groupElement.classList.add("toolbar-alwaysInOverflow-item");
                            $(groupElement).children().each(function (childIndex, childElement) {
                                if (childElement.classList.contains("toolbarGroup-overflow")) {
                                    childElement.classList.add("toolbarGroup-alwaysInOverflow");
                                }
                                childElement.classList.add("toolbar-alwaysInOverflow-item");
                            });
                        }
                    });
                };
                // Has to be within init since it uses local scoped variable functions
                this._updateOverflow = function () {
                    var isVisible = _this.$toolbar.is(":visible");
                    if ($dyn.value(_this.Visible) && isVisible) {
                        markAlwaysInOverflowItems();
                        // Retrieve/store all of the widths before we start to move content to avoid layout thrashing.
                        calculateChildWidths();
                        var elementWidth = _this.$toolbar.width();
                        // Only run overflow logic if toolbar width has changed from last time this logic was run.
                        var lastKnownWidth = $.data(_this.$toolbar[0], "lastKnownWidth");
                        var toolbarGroupsWithReflowContent = _this.$toolbar.children('[data-dyn-role="ToolbarGroup"]').length;
                        if (lastKnownWidth && lastKnownWidth === elementWidth) {
                            _this.$toolbar.removeClass("reflowContent");
                        }
                        else {
                            $.data(_this.$toolbar[0], "lastKnownWidth", elementWidth);
                            // For control gallery scenarios we need to fall back to the window width
                            // since the element doesn't have a width on first load and nothing else
                            // triggers an update after that.
                            var availableSpace = elementWidth !== undefined ? elementWidth : $(window).width();
                            /* WORKAROUND: Following code is being added as a workaround to address scenarios where only overflow button is
                            being shown in the toolbar because it is the first child in a SizeToContent width container and that has no other children
                            providing its width, i.e., all children are SizeToAvailable. In this case, we will pick toolbar's next sibling to provide
                            the available space.
              
                            We need to account presence or absence of the overflow button in calculation of element width. 1px gets added for each toolbar group
                            when layout reflow is occuring, i.e., reflowContent class is present on the toolbar.
              
                            This workaround will be removed in future via deliverable 3746499 once application teams have updated their forms.
                            */
                            if ((_this.$overflowButton && elementWidth === (_this.$overflowButton.outerWidth() + toolbarGroupsWithReflowContent)) ||
                                elementWidth === toolbarGroupsWithReflowContent) {
                                if (_this.$toolbar.next()[0]) {
                                    availableSpace = _this.$toolbar.next().width();
                                }
                            }
                            // Move elements that have been marked to always be in overflow to the overflow area before processing remaining toolbar elements.
                            _this._moveAlwaysInOverflowItems();
                            // The array exposed by the jQuery object keeps all items that matched the selector the
                            // jQuery object was created with in document order. Document order is a depth first traversal.
                            // This means parent elements appear before their children and a sibling's
                            // descendent that matched the selector appear before the the next sibling.
                            // By always starting at the end of the array, we make sure we move the deeper
                            // elements to overflow before moving their parents.
                            if (availableSpace < toolbarContentWidth()) {
                                // Moveable items comprise of:
                                // 1. Top level toolbar groups (tab or button groups)
                                // 2. Buttons inside 1st level button group or 2nd level button group inside 1st level tab
                                // 3. Buttons inside 2nd level button group
                                var moveableItems = _this.$toolbar.children(":not(.toolbar-overflow)").add(_this.$toolbar.children('[data-dyn-role="ToolbarGroup"]').children()).add(_this.$toolbar.children('[data-dyn-role="ToolbarGroup"]').children('[data-dyn-role="ToolbarGroup"]').children());
                                var indexToMove = moveableItems.length - 1;
                                while (availableSpace < toolbarContentWidth() && indexToMove >= 0) {
                                    _this._moveItemToOverflow(moveableItems[indexToMove]);
                                    indexToMove--;
                                }
                            }
                            else {
                                var moveableItems = $(".toolbar-overflow-item", _this.$overflowArea);
                                var indexToMove = moveableItems.length - 1;
                                while (indexToMove >= 0 && availableSpace > (toolbarContentWidth() + moveableItems[indexToMove].dynWidth)) {
                                    _this._removeItemFromOverflow(moveableItems[indexToMove]);
                                    indexToMove--;
                                }
                            }
                            if (_this.$overflowButton[0] && _this._checkOverflowAreaHasChildren()) {
                                _this.$overflowButton[0].style.display = "";
                            }
                            else {
                                if (_this.$overflowButton[0]) {
                                    _this.$overflowButton[0].style.display = "none";
                                }
                                if (_this.OverflowMenuOpen()) {
                                    _this.OverflowMenuOpen(false);
                                }
                            }
                            _this.$toolbar.removeClass("reflowContent");
                        }
                    }
                    // Remove reflowContent class if the overflow logic was skipped due to toolbar not being visible in the browser. We don't want to leave
                    // the content in the overflow area.
                    if (!isVisible) {
                        _this.$toolbar.removeClass("reflowContent");
                    }
                };
                // Needs to be here in init because it is used for event handlers and needs correct this context
                this._updateOverflowThrottled = function () {
                    if (_this._updateOverflowTimeout) {
                        _this._updateOverflowTimeout.cancel();
                    }
                    _this._updateOverflowTimeout = $dyn.async(_this._updateOverflow, undefined, "Toolbar overflow");
                };
                this._toolbarWatchedContent = $dyn.computed(function () {
                    var e_1, _a;
                    function watchGroup(topToolBar, group) {
                        var e_2, _a;
                        $dyn.value(group.Visible);
                        var groupChildren = $dyn.value(group.Children);
                        if (groupChildren) {
                            try {
                                for (var groupChildren_1 = __values(groupChildren), groupChildren_1_1 = groupChildren_1.next(); !groupChildren_1_1.done; groupChildren_1_1 = groupChildren_1.next()) {
                                    var groupChild = groupChildren_1_1.value;
                                    // save parent in the map for the element
                                    topToolBar._toolBarElementOverFlowMap[groupChild.Id] = { ParentContainer: groupChild._parent, OriginalRole: groupChild.element.getAttribute("role") };
                                    if (groupChild.TypeName === "ToolbarGroup") {
                                        $dyn.value(groupChild.Visible);
                                        watchGroup(topToolBar, groupChild);
                                    }
                                    else {
                                        // For Buttons the Visible and Label properties effect the width.
                                        $dyn.value(groupChild.Visible);
                                        $dyn.value(groupChild.Label);
                                    }
                                }
                            }
                            catch (e_2_1) { e_2 = { error: e_2_1 }; }
                            finally {
                                try {
                                    if (groupChildren_1_1 && !groupChildren_1_1.done && (_a = groupChildren_1.return)) _a.call(groupChildren_1);
                                }
                                finally { if (e_2) throw e_2.error; }
                            }
                        }
                    }
                    var children = $dyn.value(_this.Children);
                    if (children) {
                        try {
                            for (var children_1 = __values(children), children_1_1 = children_1.next(); !children_1_1.done; children_1_1 = children_1.next()) {
                                var child = children_1_1.value;
                                if (child.TypeName === "ToolbarGroup") {
                                    // save parent in the map for the ToolbarGroup
                                    _this._toolBarElementOverFlowMap[child.Id] = { ParentContainer: child._parent, OriginalRole: child.element.getAttribute("role") };
                                    watchGroup(_this, child);
                                }
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (children_1_1 && !children_1_1.done && (_a = children_1.return)) _a.call(children_1);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                    }
                });
                // We need to be notified whenever layout reflows for toolbar's parent. Toolbar shouldn't influence its parent's width.
                // Toolbar's width is temporarily reduced before layout reflow occurs and is restored once toolbar overflow calculations are complete.
                this._layoutReflowStartHandler = $dyn.layout.registerStartReflowHandler(this.$toolbar[0].parentElement, function () {
                    _this.$toolbar.addClass("reflowContent");
                });
                this._layoutReflowEndHandler = $dyn.layout.registerEndReflowHandler(this.$toolbar[0].parentElement, this._updateOverflowThrottled);
                // We need to update the overflow whenever our watched content changes.
                this._watchedContentOverflowSubscription = $dyn.observe(this._toolbarWatchedContent, function () {
                    $.removeData(_this.$toolbar[0], "lastKnownWidth");
                    _this._updateOverflowThrottled();
                });
                // If a replace is happening on any children elements we need to undo the moves the
                // overflow logic has done before that code runs and re-run overflow after it finishes.
                this._removeAllOverflow = function () {
                    var moveableItems = $(".toolbar-overflow-item", _this.$overflowArea);
                    $dyn.callFunction($dyn.util.ActionPaneHelpers._removeAllOverflow, _this, moveableItems);
                    $.removeData(_this.element, "lastKnownWidth");
                };
                this.$toolbar.on("contentHandlersReplaceStarted", this._removeAllOverflow);
                this._initiateOverflow = function () {
                    _this.$toolbar.addClass("reflowContent");
                    _this._updateOverflowThrottled();
                };
                this.$toolbar.on("contentHandlersReplaceFinished", this._initiateOverflow);
                // Form parts may load async so toolbar overflow logic needs to be run after a form part is loaded
                this._partCreatedHandler = function (evt, part) {
                    if (_this.Root && part) {
                        if (_this.Root.Id === part.Id) {
                            _this._initiateOverflow();
                            $(document.body).off($dyn.forms.Events.partCreated, _this._partCreatedHandler);
                        }
                    }
                };
                $(document.body).on($dyn.forms.Events.partCreated, this._partCreatedHandler);
                if (this.isInGrid()) {
                    // Grids load async so the toolbar overflow logic needs to be run after the grid is rendered
                    this._gridLayoutCompleteHandler = function (evt) {
                        if ($.contains(evt.target, _this.element)) {
                            _this._initiateOverflow();
                        }
                    };
                    $(document.body).on($dyn.forms.Events.gridLayoutCompleted, this._gridLayoutCompleteHandler);
                }
            };
            /**
             * This is the handler called when the Toolbar overflow flyout is open and a click event is detected. Determines if the flyout should stay open.
             * @internal
             * @param options The click options from the flyout binding handler
             * @returns true if the Toolbar overflow flyout should be closed by the click; otherwise, false
             */
            Toolbar.prototype.overflowClickSubscriber = function (options) {
                var $target = $(options.clickTarget);
                // Don't close the flyout if a right-click was performed, or if the click came from an element in our flyout that will open another flyout
                // or if it came from clicking on empty/disabled content in the flyout.
                return !(options.isRightClick ||
                    (options.flyoutElement &&
                        $target.closest(options.flyoutElement).length &&
                        ($target.is(options.flyoutElement) || $target.closest(".dropDialogButton, .flyoutButton-Button, [disabled]").length)));
            };
            Toolbar.prototype.dispose = function () {
                if (this._updateOverflowTimeout) {
                    this._updateOverflowTimeout.cancel();
                    this._updateOverflowTimeout = undefined;
                }
                this.$toolbar.off("contentHandlersReplaceStarted", this._removeAllOverflow);
                this.$toolbar.off("contentHandlersReplaceFinished", this._initiateOverflow);
                $(document.body).off("resetShellOnNavigation", this._updateOverflowThrottled);
                if (this._watchedContentOverflowSubscription) {
                    this._watchedContentOverflowSubscription.dispose();
                    this._watchedContentOverflowSubscription = null;
                }
                if (this._layoutReflowEndHandler) {
                    this._layoutReflowEndHandler.dispose();
                    this._layoutReflowEndHandler = null;
                }
                if (this._layoutReflowStartHandler) {
                    this._layoutReflowStartHandler.dispose();
                    this._layoutReflowStartHandler = null;
                }
                $.removeData(this.$toolbar[0], "lastKnownWidth");
                $(document.body).off($dyn.forms.Events.partCreated, this._partCreatedHandler);
                if (this._gridLayoutCompleteHandler) {
                    $(document.body).off($dyn.forms.Events.gridLayoutCompleted, this._gridLayoutCompleteHandler);
                }
                if (this._toolbarWatchedContent) {
                    if (this._toolbarWatchedContent.valueChanged && this._toolbarWatchedContent.valueChanged.clearAllDependencies) {
                        this._toolbarWatchedContent.valueChanged.clearAllDependencies();
                    }
                    this._toolbarWatchedContent = null;
                }
                _super.prototype.dispose.call(this);
            };
            /**
             * Removes specified item from the Toolbar overflow area.
             * @internal
             * @param itemToMove Item to be removed from the overflow area
             */
            Toolbar.prototype._removeItemFromOverflow = function (itemToMove) {
                $(itemToMove).detach();
                itemToMove.classList.remove("toolbar-overflow-item");
                var role = itemToMove.getAttribute("data-dyn-role");
                var controlId = itemToMove.id ? itemToMove.id : $dyn.context(itemToMove).Id;
                var originalRole = this._toolBarElementOverFlowMap[controlId] ? this._toolBarElementOverFlowMap[controlId].OriginalRole : null;
                if (this._toolBarElementOverFlowMap[controlId] && this._toolBarElementOverFlowMap[controlId].ParentContainer.element) {
                    $(this._toolBarElementOverFlowMap[controlId].ParentContainer.element).append(itemToMove);
                }
                else {
                    if (role === "ToolbarGroup" || itemToMove.classList.contains("toolbar-replace")) {
                        $(".toolbar-overflow", this.$toolbar).before(itemToMove);
                    }
                    else {
                        // Content is part of a group and needs to move into the last ToolbarGroup still in the toolbar.
                        this.$toolbar.children('[data-dyn-role="ToolbarGroup"]').last().append(itemToMove);
                    }
                }
                if (originalRole) {
                    $(itemToMove).attr("role", originalRole);
                }
                else {
                    $(itemToMove).removeAttr("role");
                }
                var controlToMove = $dyn.context(itemToMove);
                if (controlToMove) {
                    $dyn.util.ActionPaneHelpers.ApplyBarOverflow(controlToMove, false);
                }
            };
            /**
             * Checks if overflow area has children.
             * @description Returns false if the children are only tabbing container elements
             * @returns true if has children
             */
            Toolbar.prototype._checkOverflowAreaHasChildren = function () {
                if (!this.$overflowArea.children() || !this.$overflowArea.children().length) {
                    return false;
                }
                else if (this.$overflowArea.children().length === 2 &&
                    $(this.$overflowArea.children()[0]).hasClass("firstFocusable") &&
                    $(this.$overflowArea.children()[1]).hasClass("lastFocusable")) {
                    return false;
                }
                return true;
            };
            /**
             * Moves specified item to the Toolbar overflow area.
             * @param itemToMove Item to be moved to the overflow area
             */
            Toolbar.prototype._moveItemToOverflow = function (itemToMove) {
                var _this = this;
                if ($dyn.ui.removeFocus($(itemToMove))) {
                    // If removeFocus returned something we need to set the overflow as the new focused element,
                    // in a time out since it isn't initially visible.
                    $dyn.async(function () {
                        _this.$overflowButton.focus();
                    }, undefined, "Move focus to overflow button");
                }
                $(itemToMove).detach();
                if (!itemToMove.classList.contains("toolbar-alwaysInOverflow-item")) {
                    itemToMove.classList.add("toolbar-overflow-item");
                }
                if (itemToMove.classList.contains("toolbarGroup-overflow") || itemToMove.classList.contains("toolbar-replace")) {
                    this.$overflowArea.append(itemToMove);
                }
                else if (itemToMove.classList.contains("toolbar-alwaysInOverflow-item")) {
                    // Move the item marked to always be in overflow into the last toolbarGroup-alwaysInOverflow area added.
                    this.$overflowArea.children(".toolbarGroup-alwaysInOverflow").last().append(itemToMove);
                }
                else {
                    // Content is part of a group and needs to move into the last toolbarGroup-overflow area added.
                    this.$overflowArea.children(".toolbarGroup-overflow:not(.toolbarGroup-alwaysInOverflow)").last().append(itemToMove);
                }
                var controlToMove = $dyn.context(itemToMove);
                if (controlToMove) {
                    $dyn.util.ActionPaneHelpers.ApplyBarOverflow(controlToMove, true);
                }
                if (itemToMove.classList.contains("toolbarGroup-overflow")) {
                    $(itemToMove).attr("role", "group");
                }
                else {
                    $(itemToMove).attr("role", "listitem");
                }
            };
            /**
             * Move all items that are marked to always be in the overflow area
             */
            Toolbar.prototype._moveAlwaysInOverflowItems = function () {
                var moveableItems = this.$toolbar.children(".toolbar-alwaysInOverflow-item").add(this.$toolbar.children(".toolbar-alwaysInOverflow-item").children());
                var indexToMove = moveableItems.length - 1;
                while (indexToMove >= 0) {
                    this._moveItemToOverflow(moveableItems[indexToMove]);
                    indexToMove--;
                }
            };
            return Toolbar;
        }($dyn.ui.Container));
        controls.Toolbar = Toolbar;
        Toolbar.prototype.Width = $dyn.layout.Size.available;
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=Toolbar.js.map
